import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountsComponent } from './accounts/accounts.component';
import { AdmissionsComponent } from './admissions/admissions.component';
import { AttendanceComponent } from './attendance/attendance.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { PasswordresetComponent } from './passwordreset/passwordreset.component';
import { SchedulesComponent } from './schedules/schedules.component';
import { SettingsComponent } from './settings/settings.component';
import { StudentsComponent } from './students/students.component';
import { StudentDetailComponent } from './students/student-detail/student-detail.component';
import { CourseListComponent } from './components/courses/course-list.component';
import { CourseFormComponent } from './components/courses/course-form.component';
import { AuthGuard } from './guards/auth.guard';
import { RoleGuard } from './guards/role.guard';
import { TeachersComponent } from './teachers/teachers.component';
import { ProfileComponent } from './profile/profile.component';
import { GradesComponent } from './grades/grades.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'home',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', component: HomeComponent },
      {
        path: 'accounts',
        component: AccountsComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: ['ROLE_ADMIN'] }
      },
      { path: 'settings', component: SettingsComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'schedules', component: SchedulesComponent },
      { path: 'attendance', component: AttendanceComponent },
      {
        path: 'grades',
        component: GradesComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: ['ROLE_TEACHER', 'ROLE_ADMIN'] }
      },
      { path: 'admissions', component: AdmissionsComponent },
      { path: 'students/:id', component: StudentDetailComponent },
      { path: 'students', component: StudentsComponent },
      {
        path: 'teachers',
        component: TeachersComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: ['ROLE_ADMIN'] }
      },
      {
        path: 'courses',
        component: CourseListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'courses/new',
        component: CourseFormComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { expectedRoles: ['ROLE_TEACHER', 'ROLE_ADMIN'] }
      },
      {
        path: 'courses/:id/edit',
        component: CourseFormComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { expectedRoles: ['ROLE_TEACHER', 'ROLE_ADMIN'] }
      }
    ]
  },
  { path: 'resetPassword', component: PasswordresetComponent },
  { path: '**', redirectTo: '/login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
